<template>
  <search-and-pick
    :items="clientPickerItems"
    :value="value"
    @input="$emit('input', $event)"
    :label="label"
    :multiple="false"
  />
</template>

<script>
import AccessibleClient from '@/dataAccess/models/AccessibleClient'
import SearchAndPick from '@/components/SearchAndPick'

export default {
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  components: { SearchAndPick },
  created() {
    // Set initial value to current year
    this.$emit('input', new Date().getFullYear())
  },
  computed: {
    clientPickerItems() {
      return AccessibleClient.notArchivedAndAccessibleToUser().map(obj => {
        return { name: obj.fullName, avatar: obj.avatar, id: obj.id }
      })
    }
  }
}
</script>
